/* The contents of this file are generated automatically during the build process of this component.
 * If you need to make changes on these styles, go to the .scss files of this repository.
 * Once you are done, run the "npm run build" script to update this file and commit your changes, including this file.
*/

import '@webcomponents/shadycss/entrypoints/apply-shim.js';

const styleElement = document.createElement('dom-module');
styleElement.innerHTML =
  `<template>
  <style>
    /*CSS-START*/
:host([theme]) {
  box-sizing: border-box;
  border: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--button-font-family);
  line-height: var(--button-line-height);
  transition: var(--button-transition);
  -webkit-transition: var(--button-webkit-transition);
}

:host(:not([disabled])) {
  cursor: pointer;
}

:host([disabled]) {
  pointer-events: none;
  cursor: not-allowed;
  outline: none;
}

:host([size="large"]) {
  height: var(--button-large-size-height);
  padding: var(--button-large-size-padding);
}

@media only screen and (max-width: 480.98px) {
  :host([size="large"]) {
    min-width: var(--button-mobile-size-min-width);
    max-width: var(--button-mobile-size-max-width);
    font-size: var(--button-mobile-font-size);
  }
}

@media only screen and (min-width: 481px) and (max-width: 1179.98px) {
  :host([size="large"]) {
    min-width: var(--button-large-size-min-width);
    max-width: var(--button-large-size-max-width);
    font-size: var(--button-large-font-size);
  }
}

@media only screen and (min-width: 1180px) {
  :host([size="large"]) {
    min-width: var(--button-large-size-min-width);
    max-width: var(--button-large-size-max-width);
    font-size: var(--button-large-font-size);
  }
}

:host([size="standard"]) {
  height: var(--button-standard-size-height);
  padding: var(--button-standard-size-padding);
}

@media only screen and (max-width: 480.98px) {
  :host([size="standard"]) {
    min-width: var(--button-mobile-size-min-width);
    max-width: var(--button-mobile-size-max-width);
    font-size: var(--button-mobile-font-size);
  }
}

@media only screen and (min-width: 481px) and (max-width: 1179.98px) {
  :host([size="standard"]) {
    min-width: var(--button-standard-size-min-width);
    max-width: var(--button-standard-size-max-width);
    font-size: var(--button-standard-font-size);
  }
}

@media only screen and (min-width: 1180px) {
  :host([size="standard"]) {
    min-width: var(--button-standard-size-min-width);
    max-width: var(--button-standard-size-max-width);
    font-size: var(--button-standard-font-size);
  }
}

:host([size="medium"]) {
  height: var(--button-standard-size-height);
  padding: var(--button-standard-size-padding);
}

@media only screen and (max-width: 480.98px) {
  :host([size="medium"]) {
    min-width: var(--button-mobile-size-min-width);
    max-width: var(--button-mobile-size-max-width);
    font-size: var(--button-mobile-font-size);
  }
}

@media only screen and (min-width: 481px) and (max-width: 1179.98px) {
  :host([size="medium"]) {
    min-width: var(--button-standard-size-min-width);
    max-width: var(--button-standard-size-max-width);
    font-size: var(--button-standard-font-size);
  }
}

@media only screen and (min-width: 1180px) {
  :host([size="medium"]) {
    min-width: var(--button-standard-size-min-width);
    max-width: var(--button-standard-size-max-width);
    font-size: var(--button-standard-font-size);
  }
}

:host([size="mini"]) {
  height: var(--button-mini-size-height);
  padding: var(--button-mini-size-padding);
}

@media only screen and (max-width: 480.98px) {
  :host([size="mini"]) {
    min-width: var(--button-mobile-size-min-width);
    max-width: var(--button-mobile-size-max-width);
    font-size: var(--button-mobile-font-size);
  }
}

@media only screen and (min-width: 481px) and (max-width: 1179.98px) {
  :host([size="mini"]) {
    min-width: var(--button-mini-size-min-width);
    max-width: var(--button-mini-size-max-width);
    font-size: var(--button-mini-font-size);
  }
}

@media only screen and (min-width: 1180px) {
  :host([size="mini"]) {
    min-width: var(--button-mini-size-min-width);
    max-width: var(--button-mini-size-max-width);
    font-size: var(--button-mini-font-size);
  }
}

:host([size="small"]) {
  height: var(--button-mini-size-height);
  padding: var(--button-mini-size-padding);
}

@media only screen and (max-width: 480.98px) {
  :host([size="small"]) {
    min-width: var(--button-mobile-size-min-width);
    max-width: var(--button-mobile-size-max-width);
    font-size: var(--button-mobile-font-size);
  }
}

@media only screen and (min-width: 481px) and (max-width: 1179.98px) {
  :host([size="small"]) {
    min-width: var(--button-mini-size-min-width);
    max-width: var(--button-mini-size-max-width);
    font-size: var(--button-mini-font-size);
  }
}

@media only screen and (min-width: 1180px) {
  :host([size="small"]) {
    min-width: var(--button-mini-size-min-width);
    max-width: var(--button-mini-size-max-width);
    font-size: var(--button-mini-font-size);
  }
}

:host(:hover) {
  text-decoration: none;
}

:host([theme="primary"]) {
  background-color: var(--button-primary-background-color);
  border: var(--button-primary-border-width) solid var(--button-primary-border-color);
  border-radius: var(--button-primary-border-radius);
  color: var(--button-primary-font-color);
  margin: var(--button-primary-margin);
}

:host([theme="primary"]:not([disabled]):focus),
:host([theme="primary"]:not([disabled]).focus) {
  background-color: var(--button-primary-focus-color);
  border: var(--button-primary-focus-border-width) solid var(--button-primary-focus-border-color);
  border-radius: var(--button-primary-border-radius);
  color: var(--button-primary-focus-font-color);
  outline: none;
}

:host([theme="primary"]:not([disabled]):hover),
:host([theme="primary"]:not([disabled]).hover) {
  background-color: var(--button-primary-hover-color);
  border: var(--button-primary-hover-border-width) solid var(--button-primary-hover-border-color);
  color: var(--button-primary-hover-font-color);
}

:host([theme="primary"][active]:not([disabled])),
:host([theme="primary"][active]:not([disabled])) {
  background-color: var(--button-primary-active-color);
  border: var(--button-primary-active-border-width) solid var(--button-primary-active-border-color);
  color: var(--button-primary-active-font-color);
}

:host([theme="primary"]:not([disabled]):active),
:host([theme="primary"]:not([disabled]).active),
:host([theme="primary"][pressed]:not([disabled])) {
  background-color: var(--button-primary-active-color);
  border: var(--button-primary-active-border-width) solid var(--button-primary-active-border-color);
  color: var(--button-primary-active-font-color);
}

:host([theme="primary"][disabled]) {
  background-color: var(--button-primary-disabled-color);
  border: var(--button-primary-disabled-border-width) solid var(--button-primary-disabled-border-color);
  color: var(--button-primary-disabled-font-color);
}

:host([theme="secondary"]) {
  background-color: var(--button-secondary-background-color);
  border: var(--button-secondary-border-width) solid var(--button-secondary-border-color);
  border-radius: var(--button-secondary-border-radius);
  color: var(--button-secondary-font-color);
  margin: var(--button-secondary-margin);
}

:host([theme="secondary"]:not([disabled]):focus),
:host([theme="secondary"]:not([disabled]).focus) {
  background-color: var(--button-secondary-focus-color);
  border: var(--button-secondary-focus-border-width) solid var(--button-secondary-focus-border-color);
  border-radius: var(--button-secondary-border-radius);
  color: var(--button-secondary-focus-font-color);
  outline: none;
}

:host([theme="secondary"]:not([disabled]):hover),
:host([theme="secondary"]:not([disabled]).hover) {
  background-color: var(--button-secondary-hover-color);
  border: var(--button-secondary-hover-border-width) solid var(--button-secondary-hover-border-color);
  color: var(--button-secondary-hover-font-color);
}

:host([theme="secondary"][active]:not([disabled])),
:host([theme="secondary"][active]:not([disabled])) {
  background-color: var(--button-secondary-active-color);
  border: var(--button-secondary-active-border-width) solid var(--button-secondary-active-border-color);
  color: var(--button-secondary-active-font-color);
}

:host([theme="secondary"]:not([disabled]):active),
:host([theme="secondary"]:not([disabled]).active),
:host([theme="secondary"][pressed]:not([disabled])) {
  background-color: var(--button-secondary-active-color);
  border: var(--button-secondary-active-border-width) solid var(--button-secondary-active-border-color);
  color: var(--button-secondary-active-font-color);
}

:host([theme="secondary"][disabled]) {
  background-color: var(--button-secondary-disabled-color);
  border: var(--button-secondary-disabled-border-width) solid var(--button-secondary-disabled-border-color);
  color: var(--button-secondary-disabled-font-color);
}

:host([theme="tertiary"]) {
  background-color: var(--button-tertiary-background-color);
  border: var(--button-tertiary-border-width) solid var(--button-tertiary-border-color);
  border-radius: var(--button-tertiary-border-radius);
  color: var(--button-tertiary-font-color);
  margin: var(--button-tertiary-margin);
}

:host([theme="tertiary"]:not([disabled]):focus),
:host([theme="tertiary"]:not([disabled]).focus) {
  background-color: var(--button-tertiary-focus-color);
  border: var(--button-tertiary-focus-border-width) solid var(--button-tertiary-focus-border-color);
  border-radius: var(--button-tertiary-border-radius);
  color: var(--button-tertiary-focus-font-color);
  outline: none;
}

:host([theme="tertiary"]:not([disabled]):hover),
:host([theme="tertiary"]:not([disabled]).hover) {
  background-color: var(--button-tertiary-hover-color);
  border: var(--button-tertiary-hover-border-width) solid var(--button-tertiary-hover-border-color);
  color: var(--button-tertiary-hover-font-color);
}

:host([theme="tertiary"][active]:not([disabled])),
:host([theme="tertiary"][active]:not([disabled])) {
  background-color: var(--button-tertiary-active-color);
  border: var(--button-tertiary-active-border-width) solid var(--button-tertiary-active-border-color);
  color: var(--button-tertiary-active-font-color);
}

:host([theme="tertiary"]:not([disabled]):active),
:host([theme="tertiary"]:not([disabled]).active),
:host([theme="tertiary"][pressed]:not([disabled])) {
  background-color: var(--button-tertiary-active-color);
  border: var(--button-tertiary-active-border-width) solid var(--button-tertiary-active-border-color);
  color: var(--button-tertiary-active-font-color);
}

:host([theme="tertiary"][disabled]) {
  background-color: var(--button-tertiary-disabled-color);
  border: var(--button-tertiary-disabled-border-width) solid var(--button-tertiary-disabled-border-color);
  color: var(--button-tertiary-disabled-font-color);
}

:host([theme="transactional"]) {
  background-color: var(--button-transactional-background-color);
  border: var(--button-transactional-border-width) solid var(--button-transactional-border-color);
  border-radius: var(--button-transactional-border-radius);
  color: var(--button-transactional-font-color);
  margin: var(--button-transactional-margin);
}

:host([theme="transactional"]:not([disabled]):focus),
:host([theme="transactional"]:not([disabled]).focus) {
  background-color: var(--button-transactional-focus-color);
  border: var(--button-transactional-focus-border-width) solid var(--button-transactional-focus-border-color);
  border-radius: var(--button-transactional-border-radius);
  color: var(--button-transactional-focus-font-color);
  outline: none;
}

:host([theme="transactional"]:not([disabled]):hover),
:host([theme="transactional"]:not([disabled]).hover) {
  background-color: var(--button-transactional-hover-color);
  border: var(--button-transactional-hover-border-width) solid var(--button-transactional-hover-border-color);
  color: var(--button-transactional-hover-font-color);
}

:host([theme="transactional"][active]:not([disabled])),
:host([theme="transactional"][active]:not([disabled])) {
  background-color: var(--button-transactional-active-color);
  border: var(--button-transactional-active-border-width) solid var(--button-transactional-active-border-color);
  color: var(--button-transactional-active-font-color);
}

:host([theme="transactional"]:not([disabled]):active),
:host([theme="transactional"]:not([disabled]).active),
:host([theme="transactional"][pressed]:not([disabled])) {
  background-color: var(--button-transactional-active-color);
  border: var(--button-transactional-active-border-width) solid var(--button-transactional-active-border-color);
  color: var(--button-transactional-active-font-color);
}

:host([theme="transactional"][disabled]) {
  background-color: var(--button-transactional-disabled-color);
  border: var(--button-transactional-disabled-border-width) solid var(--button-transactional-disabled-border-color);
  color: var(--button-transactional-disabled-font-color);
}

:host([theme="reversed"]) {
  background-color: var(--button-reversed-background-color);
  border: var(--button-reversed-border-width) solid var(--button-reversed-border-color);
  border-radius: var(--button-reversed-border-radius);
  color: var(--button-reversed-font-color);
  margin: var(--button-reversed-margin);
}

:host([theme="reversed"]:not([disabled]):focus),
:host([theme="reversed"]:not([disabled]).focus) {
  background-color: var(--button-reversed-focus-color);
  border: var(--button-reversed-focus-border-width) solid var(--button-reversed-focus-border-color);
  border-radius: var(--button-reversed-border-radius);
  color: var(--button-reversed-focus-font-color);
  outline: none;
}

:host([theme="reversed"]:not([disabled]):hover),
:host([theme="reversed"]:not([disabled]).hover) {
  background-color: var(--button-reversed-hover-color);
  border: var(--button-reversed-hover-border-width) solid var(--button-reversed-hover-border-color);
  color: var(--button-reversed-hover-font-color);
}

:host([theme="reversed"][active]:not([disabled])),
:host([theme="reversed"][active]:not([disabled])) {
  background-color: var(--button-reversed-active-color);
  border: var(--button-reversed-active-border-width) solid var(--button-reversed-active-border-color);
  color: var(--button-reversed-active-font-color);
}

:host([theme="reversed"]:not([disabled]):active),
:host([theme="reversed"]:not([disabled]).active),
:host([theme="reversed"][pressed]:not([disabled])) {
  background-color: var(--button-reversed-active-color);
  border: var(--button-reversed-active-border-width) solid var(--button-reversed-active-border-color);
  color: var(--button-reversed-active-font-color);
}

:host([theme="reversed"][disabled]) {
  background-color: var(--button-reversed-disabled-color);
  border: var(--button-reversed-disabled-border-width) solid var(--button-reversed-disabled-border-color);
  color: var(--button-reversed-disabled-font-color);
}

:host([theme="list-action"]) {
  background-color: var(--button-inline-secondary-background-color);
  border: var(--button-inline-secondary-border-width) solid var(--button-inline-secondary-border-color);
  border-radius: var(--button-inline-secondary-border-radius);
  color: var(--button-inline-secondary-font-color);
  margin: var(--button-inline-secondary-margin);
}

:host([theme="list-action"]:not([disabled]):focus),
:host([theme="list-action"]:not([disabled]).focus) {
  background-color: var(--button-inline-secondary-focus-color);
  border: var(--button-inline-secondary-focus-border-width) solid var(--button-inline-secondary-focus-border-color);
  border-radius: var(--button-inline-secondary-border-radius);
  color: var(--button-inline-secondary-focus-font-color);
  outline: none;
}

:host([theme="list-action"]:not([disabled]):hover),
:host([theme="list-action"]:not([disabled]).hover) {
  background-color: var(--button-inline-secondary-hover-color);
  border: var(--button-inline-secondary-hover-border-width) solid var(--button-inline-secondary-hover-border-color);
  color: var(--button-inline-secondary-hover-font-color);
}

:host([theme="list-action"][active]:not([disabled])),
:host([theme="list-action"][active]:not([disabled])) {
  background-color: var(--button-inline-secondary-active-color);
  border: var(--button-inline-secondary-active-border-width) solid var(--button-inline-secondary-active-border-color);
  color: var(--button-inline-secondary-active-font-color);
}

:host([theme="list-action"]:not([disabled]):active),
:host([theme="list-action"]:not([disabled]).active),
:host([theme="list-action"][pressed]:not([disabled])) {
  background-color: var(--button-inline-secondary-active-color);
  border: var(--button-inline-secondary-active-border-width) solid var(--button-inline-secondary-active-border-color);
  color: var(--button-inline-secondary-active-font-color);
}

:host([theme="list-action"][disabled]) {
  background-color: var(--button-inline-secondary-disabled-color);
  border: var(--button-inline-secondary-disabled-border-width) solid var(--button-inline-secondary-disabled-border-color);
  color: var(--button-inline-secondary-disabled-font-color);
}

:host([theme="inline-primary"]) {
  background-color: var(--button-inline-primary-background-color);
  border: var(--button-inline-primary-border-width) solid var(--button-inline-primary-border-color);
  border-radius: var(--button-inline-primary-border-radius);
  color: var(--button-inline-primary-font-color);
  margin: var(--button-inline-primary-margin);
}

:host([theme="inline-primary"]:not([disabled]):focus),
:host([theme="inline-primary"]:not([disabled]).focus) {
  background-color: var(--button-inline-primary-focus-color);
  border: var(--button-inline-primary-focus-border-width) solid var(--button-inline-primary-focus-border-color);
  border-radius: var(--button-inline-primary-border-radius);
  color: var(--button-inline-primary-focus-font-color);
  outline: none;
}

:host([theme="inline-primary"]:not([disabled]):hover),
:host([theme="inline-primary"]:not([disabled]).hover) {
  background-color: var(--button-inline-primary-hover-color);
  border: var(--button-inline-primary-hover-border-width) solid var(--button-inline-primary-hover-border-color);
  color: var(--button-inline-primary-hover-font-color);
}

:host([theme="inline-primary"][active]:not([disabled])),
:host([theme="inline-primary"][active]:not([disabled])) {
  background-color: var(--button-inline-primary-active-color);
  border: var(--button-inline-primary-active-border-width) solid var(--button-inline-primary-active-border-color);
  color: var(--button-inline-primary-active-font-color);
}

:host([theme="inline-primary"]:not([disabled]):active),
:host([theme="inline-primary"]:not([disabled]).active),
:host([theme="inline-primary"][pressed]:not([disabled])) {
  background-color: var(--button-inline-primary-active-color);
  border: var(--button-inline-primary-active-border-width) solid var(--button-inline-primary-active-border-color);
  color: var(--button-inline-primary-active-font-color);
}

:host([theme="inline-primary"][disabled]) {
  background-color: var(--button-inline-primary-disabled-color);
  border: var(--button-inline-primary-disabled-border-width) solid var(--button-inline-primary-disabled-border-color);
  color: var(--button-inline-primary-disabled-font-color);
}

:host([theme="inline-secondary"]) {
  background-color: var(--button-inline-secondary-background-color);
  border: var(--button-inline-secondary-border-width) solid var(--button-inline-secondary-border-color);
  border-radius: var(--button-inline-secondary-border-radius);
  color: var(--button-inline-secondary-font-color);
  margin: var(--button-inline-secondary-margin);
}

:host([theme="inline-secondary"]:not([disabled]):focus),
:host([theme="inline-secondary"]:not([disabled]).focus) {
  background-color: var(--button-inline-secondary-focus-color);
  border: var(--button-inline-secondary-focus-border-width) solid var(--button-inline-secondary-focus-border-color);
  border-radius: var(--button-inline-secondary-border-radius);
  color: var(--button-inline-secondary-focus-font-color);
  outline: none;
}

:host([theme="inline-secondary"]:not([disabled]):hover),
:host([theme="inline-secondary"]:not([disabled]).hover) {
  background-color: var(--button-inline-secondary-hover-color);
  border: var(--button-inline-secondary-hover-border-width) solid var(--button-inline-secondary-hover-border-color);
  color: var(--button-inline-secondary-hover-font-color);
}

:host([theme="inline-secondary"][active]:not([disabled])),
:host([theme="inline-secondary"][active]:not([disabled])) {
  background-color: var(--button-inline-secondary-active-color);
  border: var(--button-inline-secondary-active-border-width) solid var(--button-inline-secondary-active-border-color);
  color: var(--button-inline-secondary-active-font-color);
}

:host([theme="inline-secondary"]:not([disabled]):active),
:host([theme="inline-secondary"]:not([disabled]).active),
:host([theme="inline-secondary"][pressed]:not([disabled])) {
  background-color: var(--button-inline-secondary-active-color);
  border: var(--button-inline-secondary-active-border-width) solid var(--button-inline-secondary-active-border-color);
  color: var(--button-inline-secondary-active-font-color);
}

:host([theme="inline-secondary"][disabled]) {
  background-color: var(--button-inline-secondary-disabled-color);
  border: var(--button-inline-secondary-disabled-border-width) solid var(--button-inline-secondary-disabled-border-color);
  color: var(--button-inline-secondary-disabled-font-color);
}
/*CSS-END*/
  </style>
</template>`;

styleElement.register('wdpr-button-style');
